import { Card, Descriptions, Flex, Table } from "antd";
import { t } from "i18next";
import { useContext, useMemo } from "react";
import { Modal } from "../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../context/modals.context";
import { getMonitoringDetailsTableColumns } from "../../../../modules/trackAndTrace/trackAndTrace.constants";
import { useMonitoringDetails } from "../../../../modules/trackAndTrace/trackAndTrace.queries";
import style from "./MonitoringDetailsModal.module.scss";

const MonitoringDetailsModal = () => {
  const {
    isModalVisible,
    modals: { id },
    clearModals,
  } = useContext(ModalsContext);

  const { data, isLoading } = useMonitoringDetails({ id, enabled: !!id });

  const cardTitles = useMemo(() => {
    return {
      sendingCard: data?.isPrijem
        ? t("TRACK.INFORMACIJE_O_PRIJEMU")
        : t("TRACK.INFORMACIJA_O_SLANJU"),
      receivingCard: data?.isPrijem
        ? t("TRACK.KVANTITATIVNI_PRIJEM_E_OTPREMNICE")
        : t("TRACK.INFORMACIJE_E_OTPREMNICE"),
    };
  }, [data?.isPrijem]);

  return (
    <Modal
      title={<strong className={style.title}>{t("TRACK.DETALJI")}</strong>}
      open={isModalVisible("monitoringDetailsModal")}
      name="monitoringDetailsModal"
      onCancel={clearModals}
      destroyOnClose
      width={1000}
      footer={null}
    >
      <Flex justify="center" gap={20}>
        <Card loading={isLoading} title={cardTitles?.sendingCard}>
          <Descriptions
            column={1}
            className={style.description}
            items={[
              { label: t("TRACK.ID_SLANJA"), children: data?.slanje?.slanjeId },
              ...(data?.slanje?.planiranoVremeIsporuke
                ? [
                    {
                      label: t("TRACK.PLANIRANO_VREME_ISPORUKE"),
                      children: data?.slanje?.planiranoVremeIsporuke,
                    },
                  ]
                : []),
            ]}
          />
          <Table
            loading={isLoading}
            columns={getMonitoringDetailsTableColumns()}
            dataSource={data?.slanje?.listaZaSlanje}
            pagination={
              !!data?.slanje?.listaZaSlanje?.length &&
              data?.slanje?.listaZaSlanje?.length > 5
                ? { pageSize: 5 }
                : false
            }
          />
        </Card>

        <Card loading={isLoading} title={cardTitles?.receivingCard}>
          <Descriptions
            column={1}
            className={style.description}
            items={[
              {
                label: t("TRACK.ID_OTPREMNICE"),
                children: data?.prijem?.brojOtpremnice,
              },
              ...(data?.prijem?.planiranoVremeOtpreme
                ? [
                    {
                      label: t("TRACK.PLANIRANO_VREME_OTPREME"),
                      children: data?.prijem?.planiranoVremeOtpreme,
                    },
                  ]
                : []),
              ...(data?.prijem?.vremeFizickogPrijema
                ? [
                    {
                      label: t("TRACK.VREME_FIZICKOG_PRIJEMA"),
                      children: data?.prijem?.vremeFizickogPrijema,
                    },
                  ]
                : []),
            ]}
          />
          <Table
            loading={isLoading}
            columns={getMonitoringDetailsTableColumns()}
            dataSource={data?.prijem?.listaKvantitativnogPrijema}
            pagination={
              !!data?.prijem?.listaKvantitativnogPrijema?.length &&
              data?.prijem?.listaKvantitativnogPrijema?.length > 5
                ? { pageSize: 5 }
                : false
            }
          />
        </Card>
      </Flex>
    </Modal>
  );
};

export default MonitoringDetailsModal;
